// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"80":"895aec32","371":"c02f728b","538":"7438ac28","910":"dc5727d6","983":"70944b98"}[chunkId] + ".chunk.js";
};